import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["tab", "panel"];

    connect() {
        const entries = this.entries;
        const selectedEntry = entries.find(({ tab }) => tab.getAttribute("aria-selected") === "true");

        if (selectedEntry) {
            this.activate(selectedEntry.tab);
        } else if (entries[0]) {
            this.activate(entries[0].tab);
        } else {
            this.resetUnmatchedTargets();
        }
    }

    select(event) {
        event.preventDefault();
        this.activate(event.currentTarget);
    }

    navigate(event) {
        const entries = this.entries;
        const currentIndex = entries.findIndex(({ tab }) => tab === event.currentTarget);

        if (currentIndex === -1) {
            return;
        }

        let nextIndex;

        switch (event.key) {
            case "ArrowLeft":
                nextIndex = (currentIndex - 1 + entries.length) % entries.length;
                break;
            case "ArrowRight":
                nextIndex = (currentIndex + 1) % entries.length;
                break;
            case "Home":
                nextIndex = 0;
                break;
            case "End":
                nextIndex = entries.length - 1;
                break;
            case "Enter":
            case " ":
                nextIndex = currentIndex;
                break;
            default:
                return;
        }

        event.preventDefault();
        this.activate(entries[nextIndex].tab, { focus: true });
    }

    activate(activeTab, { focus = false } = {}) {
        const activePanel = this.panelForTab(activeTab);

        if (!activePanel) {
            return;
        }

        this.tabTargets.forEach((tab) => {
            const selected = tab === activeTab;

            tab.setAttribute("aria-selected", String(selected));
            tab.tabIndex = selected ? 0 : -1;
        });

        this.panelTargets.forEach((panel) => {
            panel.hidden = panel !== activePanel;
        });

        if (focus) {
            activeTab.focus();
        }
    }

    panelForTab(tab) {
        const panelId = tab.getAttribute("aria-controls");

        return this.panelTargets.find((panel) => panel.id === panelId);
    }

    resetUnmatchedTargets() {
        this.tabTargets.forEach((tab) => {
            tab.setAttribute("aria-selected", "false");
            tab.tabIndex = -1;
        });

        this.panelTargets.forEach((panel) => {
            panel.hidden = true;
        });
    }

    get entries() {
        return this.tabTargets.map((tab) => ({ tab, panel: this.panelForTab(tab) })).filter(({ panel }) => panel);
    }
}
